import Registration from "../../components/Registration";

export default function RegistrationPage() {
	return <Registration />;
}
